import { render } from "./RegisterExtension.vue?vue&type=template&id=485051f7&scoped=true"
import script from "./RegisterExtension.vue?vue&type=script&lang=js"
export * from "./RegisterExtension.vue?vue&type=script&lang=js"

import "./RegisterExtension.vue?vue&type=style&index=0&id=485051f7&scoped=true&lang=less"

import exportComponent from "/tmp/tmp.J0U5ZeTglF/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485051f7"]])

export default __exports__